// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Base$MakerDs from "maker-ds/src/Base.bs.mjs";
import * as DataPage$FeedSync from "./DataPage.bs.mjs";
import * as UrlUtils$FeedSync from "./UrlUtils.bs.mjs";
import * as ErrorPage$FeedSync from "./ErrorPage.bs.mjs";
import * as AuthScreen$FeedSync from "../AuthScreen.bs.mjs";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.mjs";
import * as NotFoundPage$FeedSync from "./NotFoundPage.bs.mjs";
import * as SettingsPage$FeedSync from "./SettingsPage.bs.mjs";
import * as MonitoringPage$FeedSync from "./MonitoringPage.bs.mjs";
import * as RescriptReactErrorBoundary from "@rescript/react/src/RescriptReactErrorBoundary.bs.mjs";

function App(Props) {
  var url = RescriptReactRouter.useUrl(undefined, undefined);
  var path = Belt_List.toArray(url.path);
  var search = Belt_Option.getWithDefault(UrlUtils$FeedSync.getQueryParam(UrlUtils$FeedSync.getCurrentUrl(undefined), "search"), "");
  var page;
  var exit = 0;
  var len = path.length;
  if (len >= 4) {
    exit = 1;
  } else {
    switch (len) {
      case 0 :
          exit = 1;
          break;
      case 1 :
          var match = path[0];
          switch (match) {
            case "data" :
                page = React.createElement(DataPage$FeedSync.make, {
                      search: search
                    });
                break;
            case "monitoring" :
                page = React.createElement(MonitoringPage$FeedSync.make, {});
                break;
            case "admin" :
            case "settings" :
                page = React.createElement(SettingsPage$FeedSync.make, {});
                break;
            default:
              exit = 1;
          }
          break;
      case 2 :
          var match$1 = path[0];
          if (match$1 === "data") {
            var timestamp = path[1];
            page = React.createElement(DataPage$FeedSync.make, {
                  timestamp: Number(timestamp),
                  search: search
                });
          } else {
            exit = 1;
          }
          break;
      case 3 :
          var match$2 = path[0];
          if (match$2 === "data") {
            var timestamp$1 = path[1];
            var currency = path[2];
            page = React.createElement(DataPage$FeedSync.make, {
                  timestamp: Number(timestamp$1),
                  currency: currency,
                  search: search
                });
          } else {
            exit = 1;
          }
          break;
      
    }
  }
  if (exit === 1) {
    page = React.createElement(NotFoundPage$FeedSync.make, {});
  }
  return React.createElement(Base$MakerDs.make, {
              children: React.createElement(RescriptReactErrorBoundary.make, {
                    children: React.createElement(AuthScreen$FeedSync.make, {
                          children: page
                        }),
                    fallback: (function (p) {
                        return React.createElement(ErrorPage$FeedSync.make, {
                                    err: p.error
                                  });
                      })
                  })
            });
}

var make = App;

export {
  make ,
}
/* react Not a pure module */
